import { useCallback, useEffect, useState } from 'react'
import { ExpandingList } from '../../../Components/Career/ExpandingList'
import { Header } from '../../../Components/Career/Header'
import { EmployeeCareer } from '../../../Components/Career/EmployeeCareer'

import CareerApi from '../../../API/career/Career.api'
import List from '../../../API/Lists/Lists.js'
import { FilterBar } from '../../../Components/Career/filterBar'

import CountriesMapper from '../../../Utils/CountriesMapper'
import AreasMapper from '../../../Utils/AreasMapper'
import LevelsMapper from '../../../Utils/LevelsMapper'
import SubareasMapper from '../../../Utils/SubareasMapper'
import { getLabel } from '../../../Utils/getLabelById'
import Loading from '../../../Components/Loading/Loading'

export function Manager() {
	const [lists, setLists] = useState(null)
	const [filtered, setFiltered] = useState([])
	const [loading, setLoading] = useState(true)

	const loadData = useCallback(async () => {
		try {
			const [areasRes, countriesRes, levelsRes, subareasRes] = await Promise.all([List.areas(), List.countries(), List.levels(), List.subareas()])
			const id = JSON.parse(localStorage.getItem('user')).id
			const response = await CareerApi.getAllEmployee(id)

			const areas = areasRes?.map(AreasMapper.toDomain)
			const countries = countriesRes?.map(CountriesMapper.toDomain)
			const levels = levelsRes?.map(LevelsMapper.toDomain)
			const subareas = subareasRes?.map(SubareasMapper.toDomain)

			const formattedEmployees = response.map(employee => ({
				employee_id: employee.employee_id,
				country: { id: employee.country_id },
				name: employee.name,
				picture: employee.picture,
				jobname: employee.jobname,
				performance: employee.performance,
				potential: employee.potential,
				level: getLabel(levels, employee.level_id),
				area: getLabel(areas, employee.area_id),
				next_steps_hr: employee.next_steps_hr.map(step => ({
					id: step.id,
					level: getLabel(levels, step.level_id),
					area: getLabel(areas, step.area_id),
					subarea: getLabel(subareas, step.subarea_id),
				})),
				next_steps_employee: employee.next_steps_employee.map(step => ({
					id: step.id,
					level: getLabel(levels, step.level_id),
					area: getLabel(areas, step.area_id),
					subarea: getLabel(subareas, step.subarea_id),
				})),
				next_steps_algorithm: employee.next_steps_algorithm.map(step => ({
					level: getLabel(levels, step.level_id),
					area: getLabel(areas, step.area_id),
				})),
			}))

			setLists({
				employees: formattedEmployees,
				areas,
				countries,
				levels,
				subareas,
			})

			setFiltered(formattedEmployees)
		} catch (error) {
			console.error(error)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	if (loading && !lists) return <Loading />

	return (
		<div className='tw-mr-8'>
			<Header />
			<FilterBar lists={lists} filtered={filtered} setFiltered={setFiltered} />
			<ExpandingList view='hr' employees={filtered}>
				<EmployeeCareer lists={lists} load={loadData} loading={loading} setLoading={setLoading} />
			</ExpandingList>
		</div>
	)
}
